import Immutable from 'seamless-immutable'
import * as types from './types'

export const INITIAL_STATE = Immutable({
  fetching: false,
  received: false,
  content: {
    credentials: {
      email: '',
      password: '',
      remember: false
    },
    status: 0,
    error: {
      hasError: false,
      messages: []
    }
  }
})

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FETCH_SESSION: {
      const newState = state
        .setIn(['fetching'], action.payload)
        .setIn(['received'], !action.payload)

      return newState
    }

    case types.RECEIVE_SESSION: {
      const newState = state
        .setIn(['fetching'], false)
        .setIn(['received'], true)
        .setIn(['content', 'credentials'], action.payload?.credentials)
        .setIn(['content', 'status'], action.payload?.status)

      return newState
    }

    case types.RECEIVE_SESSION_ERROR: {
      const newState = state.setIn(['content', 'error'], action.payload)

      return newState
    }

    case types.RESET_SESSION_ERROR: {
      const newState = state.setIn(
        ['content', 'error'],
        INITIAL_STATE.content.error
      )

      return newState
    }

    case types.RESET_SESSION: {
      const newState = { ...INITIAL_STATE }

      return newState
    }

    default: {
      return state
    }
  }
}

export default reducer
